import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { CustomIcon, IconLibrary, SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ElementActions, ElementTypes, GaContext } from '@fcom/common/interfaces/gtm.interface';
import { Step } from '@fcom/common/interfaces/step.interface';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { GtmService } from '@fcom/common/gtm/services/gtm.service';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

import { ButtonTheme } from '../buttons/button/enums';
import { IconButtonSize, IconButtonTheme } from '../buttons/icon-button/enums';
import { IconPosition } from '../icons/enums';
import { Breadcrumb } from '../../../common-booking/interfaces/booking-header-interfaces';

@Component({
  selector: 'fcom-stepper-v2',
  templateUrl: './stepper-v2.component.html',
  styleUrl: './stepper-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StepperV2Component {
  private gtmService = inject(GtmService);
  private themeService = inject(FinnairThemeService);

  readonly isLegacy = computed(() => this.themeService.siteTheme() === FinnairTheme.LEGACY);

  readonly CustomIcon = CustomIcon;
  readonly IconLibrary = IconLibrary;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;
  readonly IconButtonSize = IconButtonSize;
  readonly IconButtonTheme = IconButtonTheme;
  readonly BOOKING_STEPS = BOOKING_STEPS;

  breadcrumbs = input.required<Breadcrumb[]>();
  currentStep = input.required<Step>();
  isTabletDown = input<boolean>();

  stepClick = output<Breadcrumb>();

  activeIndex = computed(() => {
    return (this.breadcrumbs() ?? []).findIndex((breadcrumb) => breadcrumb.active);
  });

  onBreadcrumbClick(breadcrumb: Breadcrumb, index: number): void {
    if (breadcrumb.disabled) {
      return;
    }

    if (index < this.activeIndex()) {
      this.stepClick.emit(breadcrumb);
      this.gtmService.trackElement(
        `new-stepper-step-${index + 1}-${breadcrumb.name}`,
        GaContext.BOOKING_FLOW,
        ElementTypes.BUTTON,
        undefined,
        ElementActions.CLICK
      );
    }
  }

  handleDisabledClick(event: MouseEvent, step: Breadcrumb, index: number): void {
    if (step.disabled || index > this.activeIndex()) {
      event.preventDefault();
      this.gtmService.trackElement(
        `new-stepper-disabled-step-${index + 1}-${step.name}-clicked`,
        GaContext.BOOKING_FLOW,
        ElementTypes.BUTTON,
        undefined,
        ElementActions.CLICK
      );
    }
  }
}
